import styled, { css } from 'styled-components';

import { purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { Z_INDEX } from './constants';

export const Spotlight = styled.div<{ $isEnabled: boolean; $src: string | null }>`
    display: none;
    ${({ $isEnabled }) =>
        $isEnabled &&
        purpurMedia('lg')`
        display: block;
    `};
    ${({ $src }) =>
        $src &&
        css`
            background-image: url('${$src}');
        `};
    position: fixed;
    box-sizing: content-box;
    z-index: ${Z_INDEX};
    pointer-events: none;
    background-color: transparent;
    background-repeat: no-repeat;
`;
